var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAries(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.959.974c-2.477-.95-5.321-.498-7.615 1.266-4.954 3.8-5.78 10.811-6.376 15.922-.184 1.403-.321 2.805-.505 4.207-.32 2.714-.642 5.428-.963 8.187-.275-2.76-.642-5.473-.963-8.187-.184-1.402-.321-2.804-.505-4.207-.596-5.11-1.422-12.122-6.376-15.922C10.362.476 7.518.024 5.041.974 2.611 1.924.913 4.14.5 6.854l1.789.272C2.61 5 3.895 3.326 5.729 2.602c1.881-.723 4.037-.362 5.826 1.04 4.358 3.348 5.138 9.907 5.688 14.747.184 1.402.321 2.804.505 4.206.688 5.564 1.376 11.354 1.743 16.917h2.018c.367-5.563 1.055-11.353 1.743-16.917.184-1.402.321-2.804.505-4.206.55-4.795 1.33-11.4 5.688-14.746 1.789-1.357 3.945-1.764 5.826-1.04 1.834.723 3.073 2.351 3.44 4.523l1.789-.272c-.413-2.714-2.11-4.93-4.541-5.88z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAries);
export default __webpack_public_path__ + "static/media/aries.40577a04b5077d72ab5e9845f4253a29.svg";
export { ForwardRef as ReactComponent };